import { take, put, call, fork } from 'redux-saga/effects';
import _sortBy from 'lodash/sortBy';
import Raven from 'raven-js';

import { CONFLICT, UNAUTHORIZED } from '../constants/httpStatusCodes';

import * as navigate from '../services/navigate';
import * as environmentActions from '../actions/environment';
import { delay } from '../util';

function* handleError(error) {
    // check if error is handled then return
    if (error.handled)
        return;

    if (error.status === UNAUTHORIZED) {
        if (!navigate.toLogin()) {
            Raven.captureMessage(`Still unauthorised straight after signing in`);
            yield put(environmentActions.setError(
                [
                    `We could not sign you in to Pool Booking.`,
                    `This app was not able to use your sign in.`,
                    `Please try again in a minute, or contact support if this keeps happening.`
                ],
                { reloadText: `Try again` }
            ));
        }
    } else {
        // Unexpected errors will fall into this catch all
        yield put(environmentActions.setError(
            [
                `Oops, something went wrong!`,
                `We've been notified and will look into it further.`,
                `Please try reloading the app to see if this fixes the problem.`
            ],
            { reloadText: `Reload app` }
        ));
    }
}

const getConflictReasonText = (reasons) => {
    const conflictReason = reasons[0];
    const otherConflicts = reasons.length > 1 ? `, and ${reasons.length - 1} other conflicts.` : ``;

    return `${conflictReason}${otherConflicts}`;
};

const checkForErrors = (responses) => {
    // Works out that the severity of errors corresponds to their numerical value
    // 401 > 403 > 404 > 409 > 500 range
    const filteredResponses = responses.filter(response => !response.ok);
    const responsesByErrorPriority = _sortBy(filteredResponses, response => response.status);

    return responsesByErrorPriority[0];
};

function* callApi(options) {
    const {
        apiMethod,
        id,
        apiData,
        apiQuery,
        onSuccess,
        onError,
        loading,
        postSnackbarText,
    } = options;

    if (loading) {
        yield put(environmentActions.setLoadingUpdated(loading.loadingText, loading.graphic));
    }

    if (process.env.FAKE_API)
        yield call(delay, 2 * 1000);

    var response = yield call(apiMethod, { data: apiData, query: apiQuery }, id);

    if (!response.ok) {
        if (loading) {
            yield put(environmentActions.setLoadingFinished());
        }

        if (onError)
            yield call(onError, response, id);

        yield call(handleError, response);
    } else {
        if (postSnackbarText)
            yield put(environmentActions.setSnackbar(postSnackbarText));

        if (loading) {
            yield call(finishLoading, loading.successText, loading.successGraphic || loading.graphic);
        }
    }

    return response;
}

function* finishLoading(message, graphic) {
    if (message) {
        yield put(environmentActions.setLoadingUpdated(message, graphic));
        yield call(delay, 1 * 1000);
    }

    yield put(environmentActions.setLoadingFinished());
}

export {
    checkForErrors,
    getConflictReasonText,
    handleError,
    callApi,
    finishLoading,
};



// WEBPACK FOOTER //
// ./scripts/sagas/common.js